import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const getAll = (companyId, params) =>
  axios.get(
    `/companies/${companyId}/initiate-change?${getQueryString(params)}`
  );

const get = (companyId, createdBy) =>
  axios.get(`/companies/${companyId}/initiate-change/${createdBy}`);

const getById = (trxId) => axios.get(`/companies/initiate-change/${trxId}`);

const getByBatchNumber = (batchNo) =>
  axios.get(`/companies/initiate-change/batched/${batchNo}`);

const create = (companyId, data) =>
  axios.post(`/companies/${companyId}/initiate-change`, data);

const update = (companyId, formData) =>
  axios.put(`/companies/${companyId}/initiate-change`, formData);

const remove = (companyId, initiateId) =>
  axios.delete(`/companies/${companyId}/initiate-change/${initiateId}`);

const updateByDirector = (companyId, data) =>
  axios.put(`/companies/${companyId}/initiate-change/director-approval`, data);

const changeDocumentSignature = (companyId, data) =>
  axios.put(`/companies/${companyId}/initiate-change/document-signature`, data);

const transactionReview = (companyId, data) =>
  axios.put(`/companies/${companyId}/initiate-change/review`, data);

const transactionRecall = (companyId, data) =>
  axios.put(`/companies/${companyId}/initiate-change/recall`, data);

const transactionChangeService = {
  getByBatchNumber,
  get,
  getById,
  getAll,
  create,
  update,
  remove,
  updateByDirector,
  transactionReview,
  changeDocumentSignature,
  transactionRecall,
};

export default transactionChangeService;
